import {
  SetterOrUpdater,
  atom,
  useRecoilValue,
  useSetRecoilState,
} from 'recoil';

type CameraPlayerMouseOverPosition = {
  mouseX: number;
  isHovering: boolean;
};

const cameraPlayerMouseOverPositionStateAtom =
  atom<CameraPlayerMouseOverPosition>({
    key: 'ALERT_CAMERA_PLAYER_MOUSE_OVER_POSITION_STATE',
    default: { mouseX: 0, isHovering: false },
  });

export const useAlertCameraPlayerMouseOverPositionValue =
  (): CameraPlayerMouseOverPosition => {
    const state = useRecoilValue<CameraPlayerMouseOverPosition>(
      cameraPlayerMouseOverPositionStateAtom,
    );
    return state;
  };

export const useSetAlertCameraPlayerMouseOverPosition =
  (): SetterOrUpdater<CameraPlayerMouseOverPosition> => {
    const setState = useSetRecoilState<CameraPlayerMouseOverPosition>(
      cameraPlayerMouseOverPositionStateAtom,
    );
    return setState;
  };
